import { roomService } from '../network/services/room.service';
import {ResponseError} from "../network/response/response-error";

export default {
  namespaced: true,
  state: {
    room: null,
    modalSlider: false,
    modalSliderPictures: [],
    currentModalSliderIndex: -1,
    loading: true,
    currentLiking: false
  },
  mutations: {
    SET_ROOM(state, payload) {
      state.room = payload;
    },
    SET_LOADING(state, payload) {
      state.loading = !!payload;
    },
    SET_MODAL_SLIDER (state, payload) {
      state.modalSlider = !!payload;
    },
    SET_MODAL_SLIDER_PICTURES (state, payload) {
      state.modalSliderPictures = payload;
    },
    SET_MODAL_SLIDER_INDEX (state, payload) {
      state.currentModalSliderIndex = Math.max(-1, Math.min(payload, state.modalSliderPictures.length - 1));
    },
    SET_CURRENT_LIKING (state, payload) {
      state.currentLiking = !!payload;
    }
  },
  actions: {
    async like ({commit, state, rootState}, roomId) {
      const token = rootState.client.tokens.accessToken;
      if (!token) return;
      if (state.currentLiking) return;
      commit('SET_CURRENT_LIKING', true);
      await roomService.addFavorite(roomId, token);
      commit('SET_CURRENT_LIKING', false);
    },
    async dislike ({commit, state, rootState}, roomId) {
      const token = rootState.client.tokens.accessToken;
      if (!token) return;
      if (state.currentLiking) return;
      commit('SET_CURRENT_LIKING', true);
      await roomService.removeFavorite(roomId, token);
      commit('SET_CURRENT_LIKING', false);
    },
    async fetch({ commit }, { id, lang }) {
      console.log({id, lang});
      commit('SET_LOADING', true);
      commit('SET_ROOM', null);
      const response = await roomService.fetch(id, lang);
      const room = response.get('Room.one', null);
      if (room instanceof ResponseError) {
        // TODO catch errors
      } else {
        commit('SET_ROOM', room);
      }
      commit('SET_LOADING', false);
    },
  },
};



// WEBPACK FOOTER //
// ./src/stores/room.store.js